<form [formGroup]="aEtrTradeForm">
  <div class="row">
    <div class="width-190 ms-2 field-groups">
      <div class="mt-3">
        <label for="creditorId" class="form-title text-nowrap"> <span class="required">*</span>Creditor </label>
        <ng-select
          class="custom"
          id="creditorId"
          [style.flex]="1"
          [items]="creditorList"
          [clearable]="false"
          bindLabel="name"
          bindValue="id"
          placeholder="Select Creditor"
          formControlName="creditorId"
          [searchFn]="customSearch"
          (change)="selectCreditor($event)"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.name }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <span [title]="item.name">{{ item.id }} - {{ item.name }}</span>
          </ng-template>
        </ng-select>
        <app-form-error-component [control]="aEtrTradeForm.controls['creditorId']" />
      </div>
    </div>

    <div class="width-65 ms-2 field-groups">
      <div class="mt-3">
        <label for="ccy" class="form-title"> <span class="required">*</span>Ccy </label>
        <select class="custom-form-select border-radius-100" id="ccy" formControlName="ccy">
          <option value="" disabled hidden>Select</option>
          <option *ngFor="let cc of currencyList" [value]="cc">{{ cc }}</option>
        </select>
      </div>
      <app-form-error-component [control]="aEtrTradeForm.controls['ccy']" />
    </div>

    <div class="field-groups ms-2 width-100">
      <div class="mt-3">
        <label for="issuedDate" class="form-title"> <span class="required">*</span>Issued </label>
        <div class="input-group">
          <app-date-picker id="issuedDate" formControlName="issuedDate" [maxDate]="issuedDateMaxDate" />
        </div>
        <app-form-error-component [control]="aEtrTradeForm.controls['issuedDate']" />
      </div>
    </div>

    <div class="width-85 field-groups ms-2">
      <div class="mt-3">
        <label for="deposit" class="form-title text-nowrap"> <span class="required">*</span>Deposit </label>
        <div class="input-container">
          <input
            id="deposit"
            type="text"
            [appOnlyNumber]="false"
            [allowedSign]="'.'"
            class="form-control ft-width inputNumberText"
            formControlName="deposit"
            (blur)="formatSellRate('aEtrTradeForm')"
          />
          <span>%</span>
        </div>
      </div>
      <app-form-error-component [control]="aEtrTradeForm.controls['deposit']" />
    </div>

    <div class="width-85 ms-2 field-groups">
      <div class="mt-3">
        <label for="faceValue" class="form-title text-nowrap"> <span class="required">*</span>Face Value </label>
        <input
          type="text"
          id="faceValue"
          [appOnlyNumber]="false"
          [allowedSign]="'.'"
          class="form-control text-left ft-width inputNumberText"
          maxlength="10"
          placeholder=""
          formControlName="faceValue"
        />
      </div>
      <app-form-error-component [control]="aEtrTradeForm.controls['faceValue']" />
    </div>

    <div class="width-80 field-groups ms-2">
      <div class="mt-3">
        <label for="unitPrice" class="form-title text-nowrap"> <span class="required">*</span>Unit Price </label>
        <input
          type="text"
          [appOnlyNumber]="false"
          [allowedSign]="'.'"
          class="form-control text-left ft-width inputNumberText"
          maxlength="10"
          placeholder=""
          formControlName="unitPrice"
          id="unitPrice"
          [readOnly]="type === 'f'"
        />
      </div>
      <app-form-error-component [control]="aEtrTradeForm.controls['unitPrice']" />
    </div>

    <div class="width-45 field-groups responive-mos ms-2">
      <div class="mt-3">
        <label for="months" class="form-title text-nowrap"> <span class="required">*</span>Mos </label>
        <input
          type="text"
          id="months"
          [appOnlyNumber]="false"
          [allowedSign]="'none'"
          class="form-control sd-width inputNumberText"
          placeholder=""
          formControlName="months"
          maxlength="3"
        />
      </div>
      <app-form-error-component [control]="aEtrTradeForm.controls['months']" />
    </div>
    <ng-container *ngIf="aEtrTradeForm.controls['rejectedMessage'].value">
      <div class="">
        <div class="mt-3" style="width: 98%">
          <label for="description" class="form-title text-nowrap">Rejected Message</label>
          <textarea
            readonly
            style="resize: none; min-height: unset !important"
            class="form-control ft-width"
            formControlName="rejectedMessage"
            id="description"
            row="8"
            maxlength="512"
          >
          </textarea>
        </div>
        <app-form-error-component [control]="aEtrTradeForm.controls['rejectedMessage']" />
      </div>
    </ng-container>

    <section class="documents-section">
      <ng-container *ngFor="let tradeDocType of selectedCredebtorTradeDocTypes$ | async; index as i">
        <ng-container *ngIf="tradeDocType.documentType.acronym as acronym">
          <form
            *ngIf="form2TradeDocumentsControl[i] as tradeDocControl"
            [formGroup]="tradeDocControl"
            style="display: flex; gap: 40px"
          >
            <div class="width-195 field-groups me-2">
              <div class="mt-3">
                <label
                  for="{{ acronym }}"
                  class="form-title text-nowrap"
                  [tooltip]="tradeDocType.documentType?.documentTypeName"
                >
                  <span class="required">*</span>{{ acronym }} No
                </label>
                <input
                  type="text"
                  class="form-control sd-width"
                  placeholder=""
                  formControlName="fileNo"
                  [id]="acronym"
                />
              </div>
              <app-form-error-component [control]="tradeDocControl.controls['fileNo']" />
            </div>

            <div class="width-180 field-groups me-2">
              <div class="margin-top-13px">
                <label
                  for="{{ acronym }}File"
                  class="form-title text-nowrap"
                  [tooltip]="tradeDocType.documentType?.documentTypeName"
                >
                  <span class="required">*</span>Attach {{ acronym }}
                </label>
                <div class="form-group file-upload d-flex">
                  <input
                    type="file"
                    class="file-border upload_file"
                    id="{{ acronym }}File"
                    (change)="fileChange($event, acronym)"
                    #uploadInput
                    [accept]="fileAccept"
                  />

                  <img
                    *ngIf="tradeDocControl.controls['file'].value"
                    class="ms-1 cursor-pointer"
                    src="../../../../assets/images/icon/cross-icon.svg"
                    (click)="clearAttachFileInput(tradeDocControl.controls['file'], uploadInput)"
                    alt=""
                    width="10px"
                  />
                </div>
              </div>
            </div>
          </form>
        </ng-container>
      </ng-container>
    </section>
  </div>

  <div class="col-12 bottom-fixed">
    <div class="d-flex justify-content-center mt-3">
      <button
        [disabled]="aEtrTradeForm.invalid"
        type="submit"
        class="btn btn-light me-3 btn-custom-footer save_btn"
        (click)="onSubmit()"
      >
        Submit
      </button>
      <button
        type="button"
        class="btn btn-light btn-custom-footer cancel_btn"
        data-dismiss="modal"
        (click)="closeModal()"
      >
        Cancel
      </button>
    </div>
  </div>
</form>
